import { Controller } from "@hotwired/stimulus"

// Controller for the themed page-edit sidebar's "Layout" select.
//
// Updates the preview card (thumbnail, name, description) in-place when
// the user changes the select, then submits the surrounding form so the
// server can persist `page.layout_key` and re-render the main preview pane.
//
// Distinct from `page_layout_picker_controller`, which drives the
// create-time modal picker.
export default class extends Controller {
  static targets = ["form", "thumbnail", "name", "description"]
  static values = { layouts: Object }

  change(event) {
    const key = event.target.value
    const meta = this.layoutsValue && this.layoutsValue[key]
    if (meta) {
      this.thumbnailTarget.src = meta.thumbnailPath
      this.thumbnailTarget.alt = meta.name
      this.nameTarget.textContent = meta.name
      this.descriptionTarget.textContent = meta.description || ""
    }
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
